/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TokenRoles
 */
export interface TokenRoles {
    /**
     * name
     * @type {string}
     * @memberof TokenRoles
     */
    name: string;
    /**
     * description
     * @type {string}
     * @memberof TokenRoles
     */
    description: string;
    /**
     * scopes
     * @type {string}
     * @memberof TokenRoles
     */
    scopes: string;
}

/**
 * Check if a given object implements the TokenRoles interface.
 */
export function instanceOfTokenRoles(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "scopes" in value;

    return isInstance;
}

export function TokenRolesFromJSON(json: any): TokenRoles {
    return TokenRolesFromJSONTyped(json, false);
}

export function TokenRolesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenRoles {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'scopes': json['scopes'],
    };
}

export function TokenRolesToJSON(value?: TokenRoles | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'scopes': value.scopes,
    };
}

